<template>
  <main class="tasks">
    <loading
      :active="loading"
      :can-cancel="false"
      loader="spinner"
      color="#2292ef"
      :is-full-page="true"
      :opacity="opacity"
    ></loading>
    <div class="main-section">
      <div class="container">
        <div class="main-section-data">
          <div class="row reset-row">
            <div class="col-lg-3">
              <task-filter></task-filter>

              <!--filter-secs end-->
            </div>
            <div class="col-lg-9">
              <div class="main-ws-sec">
                <div class="posts-section">
                  <div v-for="(task,index) in tasks" :key="index">
                    <card :task="task" :user_id=userId></card>
                  </div>
                  <paginate
                    v-model="currentPage"
                    :page-count="pages"
                    :prev-text="prev"
                    :next-text="next"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :page-range="3"
                  ></paginate>
                  <!-- <ul class="pagination dashboard-pagination" v-if="currentPage < 6 &&pages < 10">
                    <li :class="currentPage==1 ? 'page-item disbaled' : 'page-item'">
                      <a href class="page-link" :disabled="currentPage==1">prev</a>
                    </li>
                    <li v-for="(n,index) in pages-2" :key="index">
                      <a href class="page-link" @click.prevent="currentPage = n">{{n}}</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent="currentPage = pages-1">{{pages-1}}</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent="currentPage = pages">{{pages}}</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent="nextPage">next</a>
                    </li>
                  </ul>
				  <ul class="pagination dashboard-pagination" v-if="currentPage < 6 &&pages == 1">
                    <li v-for="(n,index) in pages-2" :key="index">
                      <a href class="page-link" @click.prevent="currentPage = n">{{n}}</a>
                    </li>
                  </ul>
				  <ul class="pagination dashboard-pagination" v-if="currentPage < 6 &&pages > 9">
                    <li class="page-item">
                      <a href class="page-link">prev</a>
                    </li>
                    <li v-for="(n,index) in 8" :key="index">
                      <a href class="page-link" @click.prevent="currentPage = n">{{n}}</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent="currentPage = pages-1">{{pages-1}}</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent="currentPage = pages">{{pages}}</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent="nextPage">next</a>
                    </li>
                  </ul>
                  <ul
                    class="pagination dashboard-pagination"
                    v-if="5 < currentPage && currentPage < pages-6"
                  >
                    <li class="page-item">
                      <a href class="page-link">prev</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent="currentPage = 1">1</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent="currentPage = 2">2</a>
                    </li>
                    <li class="page-item">
                      <a
                        href
                        class="page-link"
                        @click.prevent="currentPage = currentPage-3"
                      >{{currentPage-3}}</a>
                    </li>
                    <li class="page-item">
                      <a
                        href
                        class="page-link"
                        @click.prevent="currentPage = currentPage-2"
                      >{{currentPage-2}}</a>
                    </li>
                    <li class="page-item">
                      <a
                        href
                        class="page-link"
                        @click.prevent="currentPage = currentPage-1"
                      >{{currentPage-1}}</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent>{{currentPage}}</a>
                    </li>
                    <li class="page-item">
                      <a
                        href
                        class="page-link"
                        @click.prevent="currentPage = currentPage+1"
                      >{{currentPage+1}}</a>
                    </li>
                    <li class="page-item">
                      <a
                        href
                        class="page-link"
                        @click.prevent="currentPage = currentPage+2"
                      >{{currentPage+2}}</a>
                    </li>
                    <li class="page-item">
                      <a
                        href
                        class="page-link"
                        @click.prevent="currentPage = currentPage+3"
                      >{{currentPage+3}}</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent="currentPage = pages-1">{{pages-1}}</a>
                    </li>
                    <li class="page-item">
                      <a href class="page-link" @click.prevent="currentPage = pages">{{pages}}</a>
                    </li>
                  <li class="page-item"><a href="" class="page-link" v-for="n=currentPage-3 in currentPage+3">1</a></li>-->
                  <!-- <li class="page-item">
                      <a href class="page-link" @click.prevent="nextPage">next</a>
                    </li>
                  </ul>
                  <ul class="pagination dashboard-pagination" v-else>
					  <li class="page-item"><a href="" class="page-link">prev</a></li>
					  <li class="page-item"><a href="" class="page-link">1</a></li>
					  <li class="page-item"><a href="" class="page-link">1</a></li>
					  <li class="page-item"><a href="" class="page-link">1</a></li>
					  <li class="page-item"><a href="" class="page-link">1</a></li>
					  <li class="page-item"><a href=""  class="page-link" @click.prevent="console.log('asd')">next</a></li>
                  </ul>-->
                  <!--process-comm end-->
                </div>
                <!--posts-section end-->
              </div>
              <!--main-ws-sec end-->
            </div>
          </div>
        </div>
        <!-- main-section-data end-->
      </div>
    </div>
  </main>
</template>

<script>
import card from "./Card";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import paginate from "vuejs-paginate";

export default {
  name: "tasks",
  components: { card, Loading, paginate },
  data() {
    return {
      tasks: "",
      loading: false,
      opacity: 1,
      currentPage: 1,
      pages: 5,
	  query: "",
	  userId: null,
      prev: '<i class="fas fa-chevron-left"></i>',
      next: '<i class="fas fa-chevron-right"></i>'
    };
  },
  created() {
    this.loading = true;
    axios.get("/ajax/task").then(res => {
      this.tasks = res.data.tasks.data;
      this.currentPage = res.data.tasks.current_page;
      this.pages = res.data.tasks.last_page;
	  this.loading = false;
	  this.userId = res.data.user
    });
  },
  watch: {
    currentPage: {
      handler() {
        this.loading = true;
        axios
          .get(`/ajax/task${this.query}?page=${this.currentPage}`)
          .then(res => {
            this.tasks = res.data.tasks.data;
            this.currentPage = res.data.tasks.current_page;
            this.pages = res.data.tasks.last_page;
            this.loading = false;
          });
      }
    }
  }
};
</script>
